import { Helmet } from "react-helmet-async";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Container, Tab, Tabs } from "react-bootstrap";
import { useWebsiteName } from "../../../context/WebsiteNameContext";
import BindingTab from "./Tabs/binding";
import BindContractBranchTab from "./Tabs/branch";
import AssignProductsBranchTab from "./Tabs/assign";
import DetermineAgeTab from "./Tabs/determine";
import handleChangeWebsiteTab from "../../../commons/ChangeWebsiteTab";

export default function BindingPMServiceTabContract() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { websiteName, setWebsiteName } = useWebsiteName();
  const websiteTab = {
    key: state?.name || "branch",
    setWebsiteName,
    tabNames: {
      branch: "ผูกสัญญากับสาขา",
      binding: "ผูกสัญญากับสินค้า",
      machine: "กำหนดหมายเลขเครื่อง",
      determine: "กำหนดอายุอุปกรณ์/อะไหล่"
    }
  };

  useEffect(() => handleChangeWebsiteTab(websiteTab), []);

  return (
    <>
      <Helmet>
        <title>{websiteName}</title>
        <meta name="description" content="Bind PM Service Contract Page" />
      </Helmet>

      <Container fluid className="p-0">
        <Tabs
          justify
          defaultActiveKey={state?.name || "branch"}
          onSelect={(key) =>
            handleChangeWebsiteTab({
              ...websiteTab,
              key,
              navigated: (navi) =>
                navi &&
                navigate("/PM_work/bind", { state: { ...state, name: key } })
            })
          }
        >
          <Tab eventKey="branch" title="ผูกสัญญากับสาขา">
            {websiteName === "ผูกสัญญากับสาขา" && <BindContractBranchTab />}
          </Tab>
          <Tab eventKey="binding" title="ผูกสัญญากับสินค้า">
            {websiteName === "ผูกสัญญากับสินค้า" && <BindingTab />}
          </Tab>
          <Tab eventKey="machine" title="กำหนดหมายเลขเครื่อง">
            {websiteName === "กำหนดหมายเลขเครื่อง" && (
              <AssignProductsBranchTab />
            )}
          </Tab>
          <Tab eventKey="determine" title="กำหนดอายุอุปกรณ์/อะไหล่">
            {websiteName === "กำหนดอายุอุปกรณ์/อะไหล่" && <DetermineAgeTab />}
          </Tab>
        </Tabs>
      </Container>
    </>
  );
}
